<app-header> </app-header>

<mat-card class="loginCard">
    <mat-card-header>
        <mat-card-title class="loginTitle">PicPet</mat-card-title>
    </mat-card-header>
    <mat-card-content>
     <form>
        <table cellspacing="0">
            <tr>
                <td>
                    <mat-form-field class="loginInput">
                        <input matInput placeholder="Username"  name="username" [(ngModel)]="username" required>     
                    </mat-form-field>
                </td>
            </tr>
          <tr>
              <td>
                <mat-form-field class="loginInput">
                    <input matInput placeholder="Password"  type="password" name="password" [(ngModel)]="password" required> 
                </mat-form-field>
              </td>
          </tr>
        </table>
    </form>
        <mat-spinner [style.display]="showSpinner ? 'block' : 'none'">
            <!-- component com a rodinha de loading! -->
        </mat-spinner>
    </mat-card-content>
    <mat-card-actions>
        <button class="loginButon" mat-raised-button (click)="login()" color="primary">Login</button>
    </mat-card-actions>
</mat-card>

<app-footer></app-footer>